import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function reauthenticateMembersRequest(isLoading) {
  return {
    type: actionsTypesMembers.REAUTHENTIFICATE_MEMBERS_REQUEST,
    isLoading,
  }
}
function reauthenticateMembersFailure(isError) {
  return {
    type: actionsTypesMembers.REAUTHENTIFICATE_MEMBERS_FAILURE,
    isError,
  }
}
function reauthenticateMembersSuccess(isSuccess, userData) {
  return {
    type: actionsTypesMembers.REAUTHENTIFICATE_MEMBERS_SUCCESS,
    isSuccess,
    userData
  }
}
export function fetchReauthenticateMembersAction() {
  return function(dispatch, getState) {

    dispatch(reauthenticateMembersRequest(true))

    return backendMembers.reauthenticate()
      .then(userData => {
        dispatch(reauthenticateMembersRequest(false))
        dispatch(reauthenticateMembersSuccess(true, userData))
      })
      .catch(error => {
        dispatch(reauthenticateMembersRequest(false))
        dispatch(reauthenticateMembersFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Authentification/Reauthenticate.js